import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {ConfigText} from '../healthStatus/HealthStatus'
import ContainerContent from '../ContainerContent'

const NotFoundEmpty = (props: any) => {
    return (<ContainerContent>
        <div data-fade className={'tc emptyPadding'}
             style={{padding: '50px 0', fontSize: '24px', lineHeight: '32px', maxWidth: '500px', margin: '0 auto'}}>
            <ConfigText field={'we_are_enable'}>
                We are unable to display your results at this moment. To obtain a detailed analysis, please add or input
                the necessary biomarkers.
            </ConfigText>
            <Link to={'/form'} style={{marginTop: '20px', display: 'block'}}>Add Biomarkers</Link>

        </div>
    </ContainerContent>)
}



export default NotFoundEmpty
